<template>
  <admin-page-shell :title="$t('frontend_groovemail_safelist_ip')">
    <server-table
      class="text-center groovemail-safelist-ip-table"
      ref="serverTable"
      url="/admin/whitelist_ips"
      tableRef="safelistTable"
      :slotData="safeListSlotData"
      :tableColumns="safelistIPTableColumns"
      :tableOptions="safelistIPTableOptions"
      tableTitle="frontend_groovemail_safelist_ip"
      :buttonViaImport="safelistIpButtonViaImport"
      addNewBtnText="frontend_groovemail_safelist_ip"
      uploadFileBtnText="frontend_groovemail_safelist_ip_via_import"
      downloadSampleFileBtnText="frontend_groovemail_admin_block_sample_file"
      @downloadSampleFile="downloadSampleForSafeListingIps"
      @onFileChange="onFileChange"
      @addNewData="openSafelistIpModal"
      @loaded="hideLoader()"
      @loading="showLoader()"
    >
    </server-table>

    <gs-named-modal
      id="safeListIpModal"
      name="safelist-ip-modal"
      :title="this.$t('frontend_groovemail_safelist_ip')"
    >
      <div class="gm-admin-modal__body">
        <gs-field :label="$t('frontend_groovemail_safelist_ip')">
          <text-area
            variant="base"
            v-model="model.ips"
            :placeholder="this.$t('frontend_groovemail_safelist_ip_enter_ips')"
            rows="5"
          />
        </gs-field>
        <p class="gm-admin-tab__note">
          <span class="fa fa-info-circle"></span>
          {{ this.$t('frontend_groovemail_safelist_ip_note') }}
        </p>
        <div class="gm-admin-modal__footer">
          <gs-button variant="outline" @click="closeSafelistIpModal()">{{ $t('frontend_cancel') }}</gs-button>
          <gs-button variant="primary" @click="addIpsToSafelist()">{{ $t('frontend_save') }}</gs-button>
        </div>
      </div>
    </gs-named-modal>

    <!-- Confirmation delete modal -->
    <confirm-modal
      :ref="`confirmation-remove-ip-from-safeList`"
      :name="`confirmation-remove-ip-from-safeList`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_admin_are_you_sure_delete_safelist_ip')"
      @confirm="removeIpFromSafeList"
      @close="closeDeleteBlacklistedModal"
    />

    <!-- Confirmation import csv -->
    <confirm-modal
      :ref="`confirmation-import-csv`"
      :name="`confirmation-import-csv`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_ip_safelist_are_you_sure')"
      @confirm="confirmFileChnage"
      @close="closeFileChnageConfirm"
    />
  </admin-page-shell>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import AdminPageShell from '../AdminPageShell.vue';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';
import monthsMixin from '@/mixin/monthsMixin';
import { showRequestErrorAlert } from '@/components/showDialog.js';
import downloadCsvFile from '@/components/downloadCsvFile.js';
import { getData, postData, deleteData } from '@/utils/apiHelper.js';
import { adminUrls } from '@/utils/urls.js';

let self;

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('frontend_groovemail_safelist_ip') };
  },

  mixins: [demoModeValuesMixin, monthsMixin],

  data() {
    return {
      model: {
        ips: '',
      },
      confirmId: null,
      safelistedIps: [],
      safelistedIPsListingUrl: adminUrls.ipSafeListUrl.safelistedIPData,
      safelistIPTableColumns: ['ip_address', 'created_at', 'actions'],
      safelistIPTableOptions: {
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        filterable: ['ip_address'],
        sortable: ['ip_address', 'created_at'],
        headings: {
          ip_address: () =>
            this.$t('frontend_groovemail_contacts_step2_ip_address'),
          created_at: () => this.$t('frontend_groovemail_created_at'),
          actions: () => this.$t('frontend_groovemail_mail_lead_actions'),
        },
        requestFunction(data) {
          const requestParams = { ...data, ascending: 1 - data.ascending };
          const self = this;
          return axios
            .get(self.url, {
              params: requestParams,
            })
            .catch((e) => {
              self.dispatch('error', e);
              self.hideLoader();
            });
        },
        responseAdapter({ data }) {
          if(self.demoMode) {
            const newData = data[0]?.data.map((obj) => ({
              ...obj,
              ip_address: self.basicIpAddressText,
            }));

            return {
              data: newData,
              count: newData.length,
            };
          }
          return {
            data: data[0].data,
            count: data[0].total,
          };
        },
      },
      confirmFileTarget: null,
    };
  },

  created() {
    self = this;
  },

  watch: {
    // Used to refresh safe list table when demo mode changes
    demoMode() {
      this.$refs.serverTable.$refs.safelistTable.refresh();
    },
  },

  computed: {
    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },

	  /**
     * Returns styling for safelist IP button.
     * @return {object} - styling of button.
     */
    safelistIpButtonViaImport() {
      return {
        '--import-ip-text': this.$t(
          'frontend_groovemail_safelist_ip_via_import'
        ),
      };
    },

    /**	
     * Returns slot data for safelists table.
     * @return {array} details for slot columns for safelists table.
    */
    safeListSlotData() {
      return [
        {
          slotName: 'created_at',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.created_at
              ? `${new Date(props.row.created_at).getDate()} ${
                  this.months[new Date(props.row.created_at).getMonth()]
                }, ${new Date(props.row.created_at).getFullYear()}`
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'actions',
          slotType: 'actions',
          conditions: () => {
            return true;
          },
          classes: () => {
            return {
              outerDiv: '',
              dropdown: '',
              outerSpan: '',
            };
          },
          actionList: [
            {
              id: 0,
              name: () => this.$t('frontend_delete'),
              conditions: () => {
                return true;
              },
              callback: (props) => this.openDeleteBlacklistedModal(props.row.id),
            },
          ],
        },
      ];
    },
  },

  components: {
    AdminPageShell,
    ServerTable,
  },

  methods: {
    ...mapActions('loader', ['LOADING']),

    // show loader
    showLoader() {
      this.LOADING(true);
    },

    // hide loader
    hideLoader (){
      this.LOADING(false);
    },

    // Triggers opening modal for safelisting IP's
    openSafelistIpModal() {
      this.$root.$emit('modal-open', 'safelist-ip-modal');
      this.model.ips = '';
    },

    // Triggers closing modal for safelisting IP's
    closeSafelistIpModal() {
      this.$root.$emit('modal-close', 'safelist-ip-modal');
    },

    // Used to add IP's to safelist manually
    async addIpsToSafelist() {
      if (this.model.ips.trim()) {
        const ipData = this.model.ips.trim();
        const splittedIps = ipData.split('\n');
        splittedIps.forEach((element) => {
          if (element.trim()) {
            this.safelistedIps.push(element.trim());
          }
        });
      }
      this.$root.$emit('modal-close', 'safelist-ip-modal');

      try {
        await postData(adminUrls.ipSafeListUrl.safelistIPs, {
          whitelistIps: this.safelistedIps,
        });
        this.$refs.serverTable.$refs.safelistTable.refresh();
        this.safelistedIps = [];
        this.model.ips = '';

      } catch (error) {
        // show error alert
        showRequestErrorAlert(error?.response?.data?.error);
      }
    },


    // open Ip From Safe List modal
    async openDeleteBlacklistedModal(id) {
      // set the Confirm id
      this.confirmId = id;

      // open the modal
      this.$refs[`confirmation-remove-ip-from-safeList`].open();
    },

    // close Ip From Safe List modal
    closeDeleteBlacklistedModal() {
      // reset the Confirm id
      this.confirmId = null;
    },


	  // Used to Ip From Safe List mail
    async removeIpFromSafeList() {
      try {
        await deleteData(
          `${adminUrls.ipSafeListUrl.safelistedIPData}/${this.confirmId}`
        );
        await this.fetchIpData();
      } catch (error) {
        // show error alert
        showRequestErrorAlert(error?.response?.data?.error);
      }
    },

	  // Used to fetch Safelists Ips
    async fetchIpData() {
      try {
        const ipData = await getData(`${adminUrls.ipSafeListUrl.safelistedIPData}?query=${this.$refs.serverTable.$refs.safelistTable.filteredQuery}&limit=${this.safelistIPTableOptions.perPage}&page=${this.$refs.serverTable.$refs.safelistTable.Page}&ascending=1&byColumn=0`);
        this.$refs.serverTable.updateData(ipData?.data[0]?.data, ipData?.data[0]?.total);
      } catch (error) {
        // show error alert
        showRequestErrorAlert(error?.response?.data?.error);
      }
    },

    // Used to upload IP's to safelist
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;

      // set the file target
      this.confirmFileTarget = files;

      if (!files.length) return;

      // open the modal
      this.$refs[`confirmation-import-csv`].open();
    },
    
    // confirm file change
    async confirmFileChnage() {
      const formData = new FormData();
      formData.append('csv', this.confirmFileTarget[0]);
      
      try {
        await postData(adminUrls.ipSafeListUrl.uploadIPsToSafelist, formData);
      } catch (error) {
        // show error alert
        showRequestErrorAlert(error?.response?.data?.error);
      }
      this.$refs.serverTable.$refs.safelistTable.refresh();

      document.getElementById('upload').value = '';
    },

    // close confirm file change
    closeFileChnageConfirm() {
      this.confirmFileTarget = null;
    },

    // Used to download sample file for safelisting Ip's
    async downloadSampleForSafeListingIps() {
      try {
        await downloadCsvFile(
          adminUrls.ipSafeListUrl.downloadSampleForSafelistIPUpload,
          null,
          'ip.csv'
        );
      } catch (error) {
        // show error alert
        showRequestErrorAlert(error?.response?.data?.error);
      }
    },
  },
};
</script>